var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSeverityIconsBackgroundSuccess24(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Property 1=Success (green), SIze=24, Type=Fill and bg",
    filter: "url(#filter0_d_24505_201688)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1.5,
    width: 24,
    height: 24,
    rx: 6,
    fill: "#34CA82",
    fillOpacity: 0.08,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    id: "primary-shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 13.5C5 9.08172 8.58172 5.5 13 5.5C15.1217 5.5 17.1566 6.34285 18.6569 7.84315C20.1571 9.34344 21 11.3783 21 13.5C21 17.9183 17.4183 21.5 13 21.5C8.58172 21.5 5 17.9183 5 13.5ZM12.784 16.388L16.44 11.588V11.564C16.6143 11.3354 16.6535 11.0311 16.5426 10.7657C16.4318 10.5004 16.1878 10.3144 15.9026 10.2777C15.6174 10.2411 15.3343 10.3594 15.16 10.588L12.136 14.588L10.832 12.924C10.6562 12.6982 10.3733 12.5833 10.0899 12.6227C9.80649 12.662 9.56557 12.8496 9.45792 13.1147C9.35026 13.3798 9.39223 13.6822 9.568 13.908L11.52 16.396C11.6727 16.5892 11.9058 16.7013 12.152 16.7C12.3996 16.6994 12.633 16.5842 12.784 16.388Z",
    fill: "#31BF7B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_24505_201688",
    x: 0,
    y: 0.5,
    width: 26,
    height: 26,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.133333 0 0 0 0 0.772549 0 0 0 0 0.368627 0 0 0 0.48 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_24505_201688"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_24505_201688",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeverityIconsBackgroundSuccess24);
export default __webpack_public_path__ + "static/media/severity-icons-background-success-24.79fe2673f2626ad56dc8eef1e5cbd486.svg";
export { ForwardRef as ReactComponent };